import React, { FunctionComponent, ReactNode } from 'react'
import { Heading, Icon } from '@afterpaytouch/core'
import { PaymentMethod } from '..'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'

export const PaymentScheduleExperimentPaymentMethod: FunctionComponent = () => {
  const { sectionHeadingSize } = useCheckoutSizes()
  const { t } = useTranslation()

  const renderLabel = (): ReactNode => {
    return (
      <div className={styles.buttonCaret}>
        <Heading size={sectionHeadingSize} renderAs='h4'>
          {t('summary:changeLabel')}
        </Heading>
        <Icon.CaretRight size='ExtraSmall' title='Collapse' role='img' />
      </div>
    )
  }

  const renderLabelHeader = (): ReactNode => <Heading size={sectionHeadingSize}>{t('summary:paymentMethodTitle')}</Heading>

  return (
    <div className={styles.paymentMethodWrapper}>
      <PaymentMethod negativeMargins={false} labelHeader={renderLabelHeader()} showFloatingHeader={false} changeLabel={renderLabel()} />
    </div>
  )
}
